/*
 * 記事ページの商品導線
 * 1. 「こちらもおすすめ」: Shopifyのおすすめ機能から読み込む
 *    - まず「一緒に使う商品（complementary）」を取得。未設定で0件なら「関連商品（related）」で補う
 *    - 記事で紹介済みの商品は除外。取得に失敗・0件ならブロックごと非表示のまま
 * 2. スマホの追従購入バー: 本文内の商品カードを通り過ぎたら表示し、記事下の回遊ブロックに来たら隠す
 * 3. 購入フォームの二重送信を防ぐ
 */
(function () {
  const FETCH_TIMEOUT_MS = 8000;

  async function fetchRecommendationItems(block, intent) {
    const params = new URLSearchParams({
      section_id: 'article-recommendations',
      product_id: block.dataset.productId,
      limit: '10',
      intent: intent,
    });
    const controller = new AbortController();
    const timeoutId = setTimeout(() => controller.abort(), FETCH_TIMEOUT_MS);

    try {
      const response = await fetch(`${block.dataset.url}?${params.toString()}`, { signal: controller.signal });
      if (!response.ok) throw new Error(`recommendations ${intent}: HTTP ${response.status}`);
      const html = await response.text();
      const doc = new DOMParser().parseFromString(html, 'text/html');
      return Array.from(doc.querySelectorAll('[data-article-recommendations-source] > li'));
    } finally {
      clearTimeout(timeoutId);
    }
  }

  async function loadRecommendations(block) {
    const list = block.querySelector('[data-article-recommendations-list]');
    if (!list || !block.dataset.productId) return;

    const excludeIds = new Set(block.dataset.excludeIds.split(',').filter(Boolean));
    const limit = Number(block.dataset.limit) || 4;
    const picked = [];
    const pickedIds = new Set();

    for (const intent of ['complementary', 'related']) {
      if (picked.length >= limit) break;
      let items = [];
      try {
        items = await fetchRecommendationItems(block, intent);
      } catch (error) {
        // おすすめは補助情報なので、失敗しても記事の閲覧は止めない。原因調査用に記録だけ残す
        console.warn('[article-product-hub]', error);
        continue;
      }
      for (const item of items) {
        const id = item.dataset.productId;
        if (!id || excludeIds.has(id) || pickedIds.has(id)) continue;
        picked.push(item);
        pickedIds.add(id);
        if (picked.length >= limit) break;
      }
    }

    if (picked.length === 0) return;
    list.replaceChildren(...picked.map((item) => document.importNode(item, true)));
    block.hidden = false;
  }

  function setupStickyBuy() {
    const bar = document.querySelector('[data-article-sticky-buy]');
    const hero = document.querySelector('[data-article-product-hero]');
    const hub = document.querySelector('[data-article-product-hub]');
    if (!bar || !hero) return;

    // テーマ側の下部固定ナビ（ストアトップ等）と重ならないよう、その高さ分だけ上に出す
    const bottomNav = document.querySelector('[class*="ai-fixed-banner"]');
    const updateOffset = () => {
      const offset = bottomNav && bottomNav.offsetHeight > 0 ? bottomNav.offsetHeight : 0;
      bar.style.setProperty('--article-sticky-offset', `${offset}px`);
    };

    // IntersectionObserverは「見える⇔見えない」の切り替わりでしか通知されず、
    // 目次リンクなどで一気に飛ぶと取りこぼすため、スクロール位置から毎回判定する
    const render = () => {
      const heroPassed = hero.getBoundingClientRect().bottom < 0;
      const hubReached = hub ? hub.getBoundingClientRect().top < window.innerHeight : false;
      const shouldShow = heroPassed && !hubReached;
      bar.hidden = !shouldShow;
      document.body.classList.toggle('has-article-sticky-buy', shouldShow);
    };

    let ticking = false;
    const onScroll = () => {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(() => {
        render();
        ticking = false;
      });
    };

    updateOffset();
    render();
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', () => {
      updateOffset();
      onScroll();
    });
  }

  function preventDoubleSubmit() {
    document.addEventListener('submit', (event) => {
      const form = event.target.closest('[data-article-buy-form]');
      if (!form) return;
      const button = form.querySelector('button[type="submit"]');
      if (!button) return;
      if (button.getAttribute('aria-disabled') === 'true') {
        event.preventDefault();
        return;
      }
      button.setAttribute('aria-disabled', 'true');
      button.classList.add('loading');
    });

    // ブラウザの「戻る」でページが復元されたとき、押せない状態のまま残さない
    window.addEventListener('pageshow', () => {
      document.querySelectorAll('[data-article-buy-form] button[type="submit"]').forEach((button) => {
        button.removeAttribute('aria-disabled');
        button.classList.remove('loading');
      });
    });
  }

  function init() {
    document.querySelectorAll('[data-article-recommendations]').forEach(loadRecommendations);
    setupStickyBuy();
    preventDoubleSubmit();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
